import React from 'react';
import { Link } from 'react-router-dom';

const Physical = () => {
    return (
        <div className="page-container physical-page">
            <h1 className="page-title">Physical Well-being</h1>
            <p className="page-intro">Welcome to the Physical Well-Being section of Wholeness Forward.</p>
            
            {/* Include the image */}
            <img
                src="/images/wf-physical2.jpg" // Path to image in public folder
                alt="Person exercising"
                className="page-image"
                style={{ width: '330px', height: 'auto', marginBottom: '20px' }}
            />

            <p className="page-text">
                Physical well-being involves maintaining a healthy body through proper nutrition, regular exercise, adequate sleep, and overall self-care. 
                It is the foundation that supports our ability to function effectively in our daily lives and pursue our goals with energy and vitality.
            </p>
            <p className="page-text">
                Achieving physical well-being goes beyond just avoiding illness. It includes proactive steps like adopting a balanced diet, engaging in enjoyable physical activities, 
                getting enough rest, and managing stress. By prioritizing our physical health, we can improve our quality of life and support other dimensions of well-being.
            </p>
            <hr className="page-divider" />
            <p className="page-text">
                At Wholeness Forward, we provide resources and support to help you on your journey toward physical well-being. Explore the subtopics below to find information, tips, and community discussions that can help you achieve your health goals.
            </p>
            
            <h2 className="page-heading">Subtopics</h2>
            <ul className="content-list">
                <li><Link to="/physical/exercise" className="content-link">Exercise and Fitness</Link></li>
                        <ul>
                          <li><Link to="/exercise/cardio">Cardio/Endurance Training</Link></li>
                          <li><Link to="/exercise/strength">Strength Training</Link></li>
                          <li><Link to="/exercise/flexibility">Flexibility and Stretching</Link></li>
                        </ul>
                <li><Link to="/physical/nutrition" className="content-link">Nutrition</Link></li>
                <li><Link to="/physical/diet" className="content-link">Balanced Diet</Link></li>
                <li><Link to="/physical/hydration" className="content-link">Hydration</Link></li>
                <li><Link to="/physical/fasting" className="content-link">Intermittent Fasting</Link></li>
                <li><Link to="/physical/sleep" className="content-link">Sleep</Link></li>

                {/* <li><Link to="/physical/hydration">Hydration</Link></li> */}
                {/* <li><Link to="/physical/self-care">Self-Care and Recovery</Link></li> */}
            </ul>

            <hr className="page-divider" />
            
            <h3 className="subheading">Community Physical Well-being Discussion</h3>
            <p className="page-text">
                Join the conversation and connect with others on their physical health journeys. Share your experiences, ask questions, and gain new insights from fellow community members. 
                Whether you’re just starting out or are a seasoned fitness enthusiast, your voice matters in building a supportive community.
            </p>
            <a href="/forum/Physical" className="btn">Join the Forum</a>
        </div>
    );
};

export default Physical;
